import React from "react";
import "./weekEvent.style.scss";

const WeekEvent = ({ eventNumber, eventsTotal, eventTime, eventTitle, challengeIndex, handleDayClick, boolean, indexOfDay, dateIndex, dayString, dateString, toggleDone, justDay }) => {

    return (
        <div className={`week-event${boolean === true ? `-done` : ''}`}>
            <div
                className="left"
                onClick={() => toggleDone(challengeIndex, dateIndex)}
            >
                <div className="event-time">
                    {
                        boolean === true ? (
                            <p>{eventTime}</p>
                        ) : (
                            <p>{eventTime}</p>
                        )
                    }
                </div>
                <div className="main">
                    <div className="event-title">
                        <p>{eventTitle.length > 25 ? `${eventTitle.substring(0, 50)}...` : eventTitle}</p>
                    </div>
                    <div className="subtitle">
                        <p>{eventNumber} of {eventsTotal}</p>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="days">
                    <div
                        className={`day${indexOfDay === 1 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(0, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 1 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 2 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(1, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 2 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 3 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(2, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 3 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 4 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(3, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 4 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 5 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(4, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 5 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 6 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(5, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 6 && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                    <div
                        className={`day${indexOfDay === 0 ? `-clicked` : ''}`}
                        onClick={() => handleDayClick(6, challengeIndex, dateIndex, boolean)}
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                    >
                        {
                            indexOfDay === 0  && boolean ? (
                                <p style={{ color: 'var(--coloraccent2strong)', margin: 0,  fontWeight: "bold" }}>✓</p>
                            ) : null
                        }
                    </div>
                </div>
                <div
                    className="info-right"
                    onClick={() => toggleDone(challengeIndex, dateIndex)}
                >
                    {
                        justDay ? (
                            <p><strong>{dayString}</strong></p>
                        ) : (
                            <p><strong>{dayString}</strong> · {dateString}</p>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default WeekEvent;

